import React, { FC } from 'react';
import { Tab, usePermissions } from 'react-admin';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { PaperTabbedShowLayout, RecordTitle, Show } from '~/layout';
import DetailsTab from './components/DetailsTab';
import Aside from './components/Aside';
import { EventType } from '~/types/Event';
import { useTranslateEventsShow } from '~/resources/events/index';
import { NoPermissions } from '~/components/ra';
import { useRefresh } from 'react-admin';

const useStyles = makeStyles(() => ({
  headline: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
}));

const EventShow: FC<any> = (implicitProps) => {
  const { permissions } = usePermissions();
  const t = useTranslateEventsShow();
  const refresh = useRefresh();
  const classes = useStyles();
  if (!permissions) return null;
  if (!permissions.includes('event.list')) return <NoPermissions />;

  return (
    <Show
      {...implicitProps}
      title={
        <RecordTitle
          headline={(record: EventType) => {
            return `${record.description}`;
          }}
          headlineClassName={classes.headline}
        />
      }
      actions={null}
    >
      <PaperTabbedShowLayout>
        <Tab label={t('tabs.eventData')}>
          <DetailsTab {...implicitProps} />
        </Tab>
      </PaperTabbedShowLayout>
      <Aside refresh={refresh} />
    </Show>
  );
};

export default EventShow;
